import { DataSource, Layout, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollHistoryList extends Layout {
    searchpanelPayroll: SearchPanel;
    sourceOffPayrollHist: DataSource;
    switchSwitchProcessed: Switch;
    switchSwitchVoided: Switch;
    tablePayrollList: Table;
    textboxCheckAmount: Textbox;
    textboxCheckDate: Textbox;
    textboxCheckNumber: Textbox;
    textboxPayeeCode: Textbox;
    textboxPayeeMethod: Textbox;
    textboxPaymentMethod: Textbox;
    textboxProcessTypeSearch: Textbox;
    textboxVoidDate: Textbox;
}
